const config = {

  CAPTCHA: {
    V2: '6LcMiZkhAAAAANbYyp3L5kFKu4cidlGCHpnIsRpH',
    V3: '6Ld48NUZAAAAAGbJ2g2xzdAALwlRF6AwxzjThc4z'
  },
  CLOUD_FIRE_ID: '95QNzrEeP7RU5l5WdbyrKw',

  EU_LIST: ["AT", "BG", "BE", "EL", "LT", "PT", "ES", "LU", "RO", "CZ", "FR", "HU", "SI", "DK", "HR", "MT", "SK", "DE", "IT", "NL", "FI", "EE", "CY", "SE", "IE", "LV", "PL"],
  COUNTRIES: [{ label: "Afghanistan", phone: "+93", value: "AF" }, { label: "Albania", phone: "+355", value: "AL" }, { label: "Algeria", phone: "+213", value: "DZ" }, { label: "American Samoa", phone: "+1684", value: "AS" }, { label: "Andorra", phone: "+376", value: "AD" }, { label: "Angola", phone: "+244", value: "AO" }, { label: "Anguilla", phone: "+1264", value: "AI" }, { label: "Antarctica", phone: "+672", value: "AQ" }, { label: "Antigua and Barbuda", phone: "+1268", value: "AG" }, { label: "Argentina", phone: "+54", value: "AR" }, { label: "Armenia", phone: "+374", value: "AM" }, { label: "Aruba", phone: "+297", value: "AW" }, { label: "Australia", phone: "+61", value: "AU" }, { label: "Austria", phone: "+43", value: "AT" }, { label: "Azerbaijan", phone: "+994", value: "AZ" }, { label: "Bahamas", phone: "+1242", value: "BS" }, { label: "Bahrain", phone: "+973", value: "BH" }, { label: "Bangladesh", phone: "+880", value: "BD" }, { label: "Barbados", phone: "+1246", value: "BB" }, { label: "Belarus", phone: "+375", value: "BY" }, { label: "Belgium", phone: "+32", value: "BE" }, { label: "Belize", phone: "+501", value: "BZ" }, { label: "Benin", phone: "+229", value: "BJ" }, { label: "Bermuda", phone: "+1441", value: "BM" }, { label: "Bhutan", phone: "+975", value: "BT" }, { label: "Bolivia", phone: "+591", value: "BO" }, { label: "Bonaire", phone: "+5997", value: "BQ" }, { label: "Bosnia and Herzegovina", phone: "+387", value: "BA" }, { label: "Botswana", phone: "+267", value: "BW" }, { label: "Bouvet Island", phone: "+47", value: "BV" }, { label: "Brazil", phone: "+55", value: "BR" }, { label: "British Indian Ocean Territory", phone: "+246", value: "IO" }, { label: "British Virgin Islands", phone: "+1284", value: "VG" }, { label: "Brunei", phone: "+673", value: "BN" }, { label: "Bulgaria", phone: "+359", value: "BG" }, { label: "Burkina Faso", phone: "+226", value: "BF" }, { label: "Burundi", phone: "+257", value: "BI" }, { label: "Cambodia", phone: "+855", value: "KH" }, { label: "Cameroon", phone: "+237", value: "CM" }, { label: "Canada", phone: "+1", value: "CA" }, { label: "Cape Verde", phone: "+238", value: "CV" }, { label: "Cayman Islands", phone: "+1345", value: "KY" }, { label: "Central African Republic", phone: "+236", value: "CF" }, { label: "Chad", phone: "+235", value: "TD" }, { label: "Chile", phone: "+56", value: "CL" }, { label: "China", phone: "+86", value: "CN" }, { label: "Christmas Island", phone: "+61", value: "CX" }, { label: "Cocos [Keeling] Islands", phone: "+61", value: "CC" }, { label: "Colombia", phone: "+57", value: "CO" }, { label: "Comoros", phone: "+269", value: "KM" }, { label: "Cook Islands", phone: "+682", value: "CK" }, { label: "Costa Rica", phone: "+506", value: "CR" }, { label: "Croatia", phone: "+385", value: "HR" }, { label: "Cuba", phone: "+53", value: "CU" }, { label: "Curacao", phone: "+5999", value: "CW" }, { label: "Cyprus", phone: "+357", value: "CY" }, { label: "Czech Republic", phone: "+420", value: "CZ" }, { label: "Democratic Republic of the Congo", phone: "+243", value: "CD" }, { label: "Denmark", phone: "+45", value: "DK" }, { label: "Djibouti", phone: "+253", value: "DJ" }, { label: "Dominica", phone: "+1767", value: "DM" }, { label: "Dominican Republic", phone: "+1809,1829,1849", value: "DO" }, { label: "East Timor", phone: "+670", value: "TL" }, { label: "Ecuador", phone: "+593", value: "EC" }, { label: "Egypt", phone: "+20", value: "EG" }, { label: "El Salvador", phone: "+503", value: "SV" }, { label: "Equatorial Guinea", phone: "+240", value: "GQ" }, { label: "Eritrea", phone: "+291", value: "ER" }, { label: "Estonia", phone: "+372", value: "EE" }, { label: "Ethiopia", phone: "+251", value: "ET" }, { label: "Falkland Islands", phone: "+500", value: "FK" }, { label: "Faroe Islands", phone: "+298", value: "FO" }, { label: "Fiji", phone: "+679", value: "FJ" }, { label: "Finland", phone: "+358", value: "FI" }, { label: "France", phone: "+33", value: "FR" }, { label: "French Guiana", phone: "+594", value: "GF" }, { label: "French Polynesia", phone: "+689", value: "PF" }, { label: "French Southern Territories", phone: "+262", value: "TF" }, { label: "Gabon", phone: "+241", value: "GA" }, { label: "Gambia", phone: "+220", value: "GM" }, { label: "Georgia", phone: "+995", value: "GE" }, { label: "Germany", phone: "+49", value: "DE" }, { label: "Ghana", phone: "+233", value: "GH" }, { label: "Gibraltar", phone: "+350", value: "GI" }, { label: "Greece", phone: "+30", value: "GR" }, { label: "Greenland", phone: "+299", value: "GL" }, { label: "Grenada", phone: "+1473", value: "GD" }, { label: "Guadeloupe", phone: "+590", value: "GP" }, { label: "Guam", phone: "+1671", value: "GU" }, { label: "Guatemala", phone: "+502", value: "GT" }, { label: "Guernsey", phone: "+44", value: "GG" }, { label: "Guinea", phone: "+224", value: "GN" }, { label: "Guinea-Bissau", phone: "+245", value: "GW" }, { label: "Guyana", phone: "+592", value: "GY" }, { label: "Haiti", phone: "+509", value: "HT" }, { label: "Heard Island and McDonald Islands", phone: "+61", value: "HM" }, { label: "Honduras", phone: "+504", value: "HN" }, { label: "Hong Kong", phone: "+852", value: "HK" }, { label: "Hungary", phone: "+36", value: "HU" }, { label: "Iceland", phone: "+354", value: "IS" }, { label: "India", phone: "+91", value: "IN" }, { label: "Indonesia", phone: "+62", value: "ID" }, { label: "Iran", phone: "+98", value: "IR" }, { label: "Iraq", phone: "+964", value: "IQ" }, { label: "Ireland", phone: "+353", value: "IE" }, { label: "Isle of Man", phone: "+44", value: "IM" }, { label: "Israel", phone: "+972", value: "IL" }, { label: "Italy", phone: "+39", value: "IT" }, { label: "Ivory Coast", phone: "+225", value: "CI" }, { label: "Jamaica", phone: "+1876", value: "JM" }, { label: "Japan", phone: "+81", value: "JP" }, { label: "Jersey", phone: "+44", value: "JE" }, { label: "Jordan", phone: "+962", value: "JO" }, { label: "Kazakhstan", phone: "+76,77", value: "KZ" }, { label: "Kenya", phone: "+254", value: "KE" }, { label: "Kiribati", phone: "+686", value: "KI" }, { label: "Kosovo", phone: "+377,381,383,386", value: "XK" }, { label: "Kuwait", phone: "+965", value: "KW" }, { label: "Kyrgyzstan", phone: "+996", value: "KG" }, { label: "Laos", phone: "+856", value: "LA" }, { label: "Latvia", phone: "+371", value: "LV" }, { label: "Lebanon", phone: "+961", value: "LB" }, { label: "Lesotho", phone: "+266", value: "LS" }, { label: "Liberia", phone: "+231", value: "LR" }, { label: "Libya", phone: "+218", value: "LY" }, { label: "Liechtenstein", phone: "+423", value: "LI" }, { label: "Lithuania", phone: "+370", value: "LT" }, { label: "Luxembourg", phone: "+352", value: "LU" }, { label: "Macao", phone: "+853", value: "MO" }, { label: "Madagascar", phone: "+261", value: "MG" }, { label: "Malawi", phone: "+265", value: "MW" }, { label: "Malaysia", phone: "+60", value: "MY" }, { label: "Maldives", phone: "+960", value: "MV" }, { label: "Mali", phone: "+223", value: "ML" }, { label: "Malta", phone: "+356", value: "MT" }, { label: "Marshall Islands", phone: "+692", value: "MH" }, { label: "Martinique", phone: "+596", value: "MQ" }, { label: "Mauritania", phone: "+222", value: "MR" }, { label: "Mauritius", phone: "+230", value: "MU" }, { label: "Mayotte", phone: "+262", value: "YT" }, { label: "Mexico", phone: "+52", value: "MX" }, { label: "Micronesia", phone: "+691", value: "FM" }, { label: "Moldova", phone: "+373", value: "MD" }, { label: "Monaco", phone: "+377", value: "MC" }, { label: "Mongolia", phone: "+976", value: "MN" }, { label: "Montenegro", phone: "+382", value: "ME" }, { label: "Montserrat", phone: "+1664", value: "MS" }, { label: "Morocco", phone: "+212", value: "MA" }, { label: "Mozambique", phone: "+258", value: "MZ" }, { label: "Myanmar [Burma]", phone: "+95", value: "MM" }, { label: "Namibia", phone: "+264", value: "NA" }, { label: "Nauru", phone: "+674", value: "NR" }, { label: "Nepal", phone: "+977", value: "NP" }, { label: "Netherlands", phone: "+31", value: "NL" }, { label: "New Caledonia", phone: "+687", value: "NC" }, { label: "New Zealand", phone: "+64", value: "NZ" }, { label: "Nicaragua", phone: "+505", value: "NI" }, { label: "Niger", phone: "+227", value: "NE" }, { label: "Nigeria", phone: "+234", value: "NG" }, { label: "Niue", phone: "+683", value: "NU" }, { label: "Norfolk Island", phone: "+672", value: "NF" }, { label: "North Korea", phone: "+850", value: "KP" }, { label: "North Macedonia", phone: "+389", value: "MK" }, { label: "Northern Mariana Islands", phone: "+1670", value: "MP" }, { label: "Norway", phone: "+47", value: "NO" }, { label: "Oman", phone: "+968", value: "OM" }, { label: "Pakistan", phone: "+92", value: "PK" }, { label: "Palau", phone: "+680", value: "PW" }, { label: "Palestine", phone: "+970", value: "PS" }, { label: "Panama", phone: "+507", value: "PA" }, { label: "Papua New Guinea", phone: "+675", value: "PG" }, { label: "Paraguay", phone: "+595", value: "PY" }, { label: "Peru", phone: "+51", value: "PE" }, { label: "Philippines", phone: "+63", value: "PH" }, { label: "Pitcairn Islands", phone: "+64", value: "PN" }, { label: "Poland", phone: "+48", value: "PL" }, { label: "Portugal", phone: "+351", value: "PT" }, { label: "Puerto Rico", phone: "+1787,1939", value: "PR" }, { label: "Qatar", phone: "+974", value: "QA" }, { label: "Republic of the Congo", phone: "+242", value: "CG" }, { label: "Romania", phone: "+40", value: "RO" }, { label: "Russia", phone: "+7", value: "RU" }, { label: "Rwanda", phone: "+250", value: "RW" }, { label: "Réunion", phone: "+262", value: "RE" }, { label: "Saint Barthélemy", phone: "+590", value: "BL" }, { label: "Saint Helena", phone: "+290", value: "SH" }, { label: "Saint Kitts and Nevis", phone: "+1869", value: "KN" }, { label: "Saint Lucia", phone: "+1758", value: "LC" }, { label: "Saint Martin", phone: "+590", value: "MF" }, { label: "Saint Pierre and Miquelon", phone: "+508", value: "PM" }, { label: "Saint Vincent and the Grenadines", phone: "+1784", value: "VC" }, { label: "Samoa", phone: "+685", value: "WS" }, { label: "San Marino", phone: "+378", value: "SM" }, { label: "Saudi Arabia", phone: "+966", value: "SA" }, { label: "Senegal", phone: "+221", value: "SN" }, { label: "Serbia", phone: "+381", value: "RS" }, { label: "Seychelles", phone: "+248", value: "SC" }, { label: "Sierra Leone", phone: "+232", value: "SL" }, { label: "Singapore", phone: "+65", value: "SG" }, { label: "Sint Maarten", phone: "+1721", value: "SX" }, { label: "Slovakia", phone: "+421", value: "SK" }, { label: "Slovenia", phone: "+386", value: "SI" }, { label: "Solomon Islands", phone: "+677", value: "SB" }, { label: "Somalia", phone: "+252", value: "SO" }, { label: "South Africa", phone: "+27", value: "ZA" }, { label: "South Georgia and the South Sandwich Islands", phone: "+500", value: "GS" }, { label: "South Korea", phone: "+82", value: "KR" }, { label: "South Sudan", phone: "+211", value: "SS" }, { label: "Spain", phone: "+34", value: "ES" }, { label: "Sri Lanka", phone: "+94", value: "LK" }, { label: "Sudan", phone: "+249", value: "SD" }, { label: "Surilabel", phone: "+597", value: "SR" }, { label: "Svalbard and Jan Mayen", phone: "+4779", value: "SJ" }, { label: "Swaziland", phone: "+268", value: "SZ" }, { label: "Sweden", phone: "+46", value: "SE" }, { label: "Switzerland", phone: "+41", value: "CH" }, { label: "Syria", phone: "+963", value: "SY" }, { label: "São Tomé and Príncipe", phone: "+239", value: "ST" }, { label: "Taiwan", phone: "+886", value: "TW" }, { label: "Tajikistan", phone: "+992", value: "TJ" }, { label: "Tanzania", phone: "+255", value: "TZ" }, { label: "Thailand", phone: "+66", value: "TH" }, { label: "Togo", phone: "+228", value: "TG" }, { label: "Tokelau", phone: "+690", value: "TK" }, { label: "Tonga", phone: "+676", value: "TO" }, { label: "Trinidad and Tobago", phone: "+1868", value: "TT" }, { label: "Tunisia", phone: "+216", value: "TN" }, { label: "Turkey", phone: "+90", value: "TR" }, { label: "Turkmenistan", phone: "+993", value: "TM" }, { label: "Turks and Caicos Islands", phone: "+1649", value: "TC" }, { label: "Tuvalu", phone: "+688", value: "TV" }, { label: "U.S. Minor Outlying Islands", phone: "+1", value: "UM" }, { label: "U.S. Virgin Islands", phone: "+1340", value: "VI" }, { label: "Uganda", phone: "+256", value: "UG" }, { label: "Ukraine", phone: "+380", value: "UA" }, { label: "United Arab Emirates", phone: "+971", value: "AE" }, { label: "United Kingdom", phone: "+44", value: "GB" }, { label: "United States", phone: "+1", value: "US" }, { label: "Uruguay", phone: "+598", value: "UY" }, { label: "Uzbekistan", phone: "+998", value: "UZ" }, { label: "Vanuatu", phone: "+678", value: "VU" }, { label: "Vatican City", phone: "+379", value: "VA" }, { label: "Venezuela", phone: "+58", value: "VE" }, { label: "Vietnam", phone: "+84", value: "VN" }, { label: "Wallis and Futuna", phone: "+681", value: "WF" }, { label: "Western Sahara", phone: "+212", value: "EH" }, { label: "Yemen", phone: "+967", value: "YE" }, { label: "Zambia", phone: "+260", value: "ZM" }, { label: "Zimbabwe", phone: "+263", value: "ZW" }, { label: "Åland", phone: "+358", value: "AX" }],

  API_ROOT: "https://api-internal.sellix.io/v1",
  // API_ROOT: "https://api-staging-dzmitry.sellix.aws/v1",
  // API_ROOT: "https://api-staging-elvis.sellix.aws:8443/v1",

  CDN_FLAGS_URL: 'https://cdn.sellix.io/static/flags/',
  CDN_LOGO_URL: 'https://cdn.sellix.io/static/logo',
  CDN_CRYPTO_URL: 'https://cdn.sellix.io/static/crypto',
  CDN_PREVIEWS_URL: 'https://cdn.sellix.io/static/previews',
  CDN_PREVIEWS_LANDING_URL: 'https://cdn.sellix.io/static/previews/landing',

  CURRENCY_OPTIONS: [
    { value: 'USD', label: 'USD' },
    { value: 'EUR', label: 'EUR' },
    { value: 'JPY', label: 'JPY' },

    { value: 'GBP', label: 'GBP' },
    { value: 'AUD', label: 'AUD' },
    { value: 'CAD', label: 'CAD' },
    { value: 'CHF', label: 'CHF' },
    { value: 'CNY', label: 'CNY' },
    { value: 'SEK', label: 'SEK' },
    { value: 'NZD', label: 'NZD' },
    { value: 'PLN', label: 'PLN' },
    { value: 'ILS', label: 'ILS' },

    { value: 'HKD', label: 'HKD' },
    { value: 'ISK', label: 'ISK' },
    { value: 'PHP', label: 'PHP' },
    { value: 'DKK', label: 'DKK' },
    { value: 'HUF', label: 'HUF' },
    { value: 'CZK', label: 'CZK' },
    { value: 'RON', label: 'RON' },

    { value: 'IDR', label: 'IDR' },
    { value: 'INR', label: 'INR' },
    { value: 'BRL', label: 'BRL' },
    { value: 'RUB', label: 'RUB' },
    { value: 'HRK', label: 'HRK' },
    { value: 'THB', label: 'THB' },
    { value: 'MYR', label: 'MYR' },

    { value: 'BGN', label: 'BGN' },
    { value: 'TRY', label: 'TRY' },
    { value: 'NOK', label: 'NOK' },
    { value: 'ZAR', label: 'ZAR' },
    { value: 'MXN', label: 'MXN' },
    { value: 'SGD', label: 'SGD' },
    { value: 'KRW', label: 'KRW' },
  ],

  CURRENCY_LIST: {
    USD: '$',
    EUR: '€',
    AUD: 'A$',
    GBP: '£',
    JPY: '¥',
    CAD: 'C$',
    CHF: 'CHF',
    CNY: '¥',
    SEK: 'kr',
    NZD: 'NZD',
    PLN: 'zł',
    ILS: '₪',

    HKD: 'HK$',
    ISK: 'Íkr',
    PHP: '₱',
    DKK: 'Kr.',
    HUF: 'Ft',
    CZK: 'Kč',
    RON: 'L',

    IDR: 'Rp',
    INR: '₹',
    BRL: 'R$',
    RUB: '₽',
    HRK: 'Kn',
    THB: '฿',
    MYR: 'RM',

    BGN: 'лв.',
    TRY: '₺',
    NOK: 'kr',
    ZAR: 'R',
    MXN: 'Mex$',
    SGD: 'S$',
    KRW: '₩'
  },

  STATUS_OPTIONS: [
    { value: 'all', label: 'All Statuses' },
    { value: 'PENDING', label: 'Pending' },
    { value: 'PARTIAL', label: 'Partial' },
    { value: 'COMPLETED', label: 'Completed' },
    { value: 'VOIDED', label: 'Cancelled' },
    { value: 'WAITING_FOR_CONFIRMATIONS', label: 'Confirmation' },
    { value: 'WAITING_SHOP_ACTION', label: 'Shop Action' },
    { value: 'REVERSED', label: 'Reversed' },
    { value: 'REFUNDED', label: 'Refunded' },
    { value: 'CUSTOMER_DISPUTE_ONGOING', label: 'Ongoing Dispute' }
  ],

  CARDS: {
    VISA: "https://cdn.sellix.io/static/gateways/visa.svg",
    MASTERCARD: "https://cdn.sellix.io/static/gateways/mastercard.png",
    AMERICANEXPRESS: "https://cdn.sellix.io/static/gateways/american-express.png",
    APPLEPAY: "https://cdn.sellix.io/static/gateways/apple-pay-logo-icon.png",
    GOOGLEPAY: "https://cdn.sellix.io/static/gateways/google-pay.svg",
  },

  PAYMENT_ICONS: {
    PAYPAL_EXTRA: {
    },

    STRIPE_EXTRA: {
    },
  },

  LANGUAGES: {
    'ar-sa': {
      code: 'ar-sa',
      title: 'Arabic (Saudi Arabia)',
      short: 'Arabic',
      imgUrl: `https://cdn.sellix.io/static/flags/sa.svg`,
      rtl: true,
    },
    'zh-cn': {
      code: 'zh-cn',
      title: 'Chinese (China)',
      short: 'Chinese',
      imgUrl: `https://cdn.sellix.io/static/flags/cn.svg`,
    },
    nl: {
      code: 'nl',
      title: 'Dutch',
      imgUrl: `https://cdn.sellix.io/static/flags/nl.svg`,
    },
    pl: {
      code: 'pl',
      title: 'Polish',
      imgUrl: `https://cdn.sellix.io/static/flags/pl.svg`,
    },
    en: {
      code: 'en',
      title: 'English',
      imgUrl: `https://cdn.sellix.io/static/flags/gb.svg`,
    },
    fr: {
      code: 'fr',
      title: 'French',
      imgUrl: `https://cdn.sellix.io/static/flags/fr.svg`,
    },
    de: {
      code: 'de',
      title: 'German',
      imgUrl: `https://cdn.sellix.io/static/flags/de.svg`,
    },
    it: {
      code: 'it',
      title: 'Italian',
      imgUrl: `https://cdn.sellix.io/static/flags/it.svg`,
    },
    ja: {
      code: 'ja',
      title: 'Japanese',
      imgUrl: `https://cdn.sellix.io/static/flags/jp.svg`,
    },
    pt: {
      code: 'pt',
      title: 'Portuguese',
      imgUrl: `https://cdn.sellix.io/static/flags/pt.svg`,
    },
    ru: {
      code: 'ru',
      title: 'Russian',
      imgUrl: `https://cdn.sellix.io/static/flags/ru.svg`,
    },
    es: {
      code: 'es',
      title: 'Spanish',
      imgUrl: `https://cdn.sellix.io/static/flags/es.svg`,
    },
  },


  GATEWAY_OPTIONS: [
    { value: 'all', label: 'All Gateways' },
    { value: 'PAYPAL', label: 'PayPal' },
    { value: 'BITCOIN', label: 'Bitcoin' },
    { value: 'LITECOIN', label: 'Litecoin' },
    { value: 'TRON', label: 'Tron' },
    { value: 'ETHEREUM', label: 'Ethereum' },
    { value: 'BINANCE_COIN', label: 'Binance Coin' },
    { value: 'CRONOS', label: 'Cronos' },
    { value: 'USDC', label: 'USDC' },
    { value: 'USDT', label: 'USDT' },
    { value: 'PLZ', label: 'Plaentz Token' },
    { value: 'POLYGON', label: 'Polygon' },
    { value: 'BITCOIN_CASH', label: 'Bitcoin Cash' },
    { value: 'NANO', label: 'Nano' },
    { value: 'MONERO', label: 'Monero' },
    { value: 'BITCOIN_LN', label: 'Bitcoin Lightning Network' },
    { value: 'CONCORDIUM', label: 'Concordium' },
    { value: 'BINANCE', label: 'Binance' },

    { value: "DAI", label: "DAI" },
    { value: "SHIB", label: "Shiba Inu" },
    { value: "APE", label: "ApeCoin" },
    { value: "PEPE", label: "Pepe" },
    { value: "WETH", label: "WETH" },

    { value: 'RIPPLE', label: 'Ripple' },
    { value: 'SOLANA', label: 'Solana' },

    { value: 'SKRILL', label: 'Skrill' },
    { value: 'PERFECT_MONEY', label: 'Perfect Money' },
    { value: 'CASH_APP', label: 'Cash App' },
    { value: 'STRIPE', label: 'Stripe' }
  ],

  PAYMENT_OPTS: {

  },

  PAYMENT_FULL_NAME: {

  },

  ORDER_STATUS: {
    PENDING: 'Pending',
    COMPLETED: 'Completed',
    VOIDED: 'Cancelled',
    WAITING_FOR_CONFIRMATIONS: 'Confirmation',
    WAITING_SHOP_ACTION: 'Waiting for shop action',
    PARTIAL: 'Partial',
    REVERSED: 'Reversed',
    REFUNDED: 'Refunded',
    CUSTOMER_DISPUTE_ONGOING: 'Ongoing Dispute'
  },

  REWARDS: {
    CLAUSES: {
      LEAVE_POSITIVE_REVIEW: {
        title: 'Leave a Review',
      },
      TOP_UP_BALANCE: {
        title: 'Top Up Bonus',
      },
      EARN_X_FROM_REFERRALS: {
        title: 'Earn X% from Referrals',
      },
      SPEND_X_AMOUNT: {
        title: 'Spend $X Get Y',
      },
      CASHBACK_GIFT: {
        title: 'Cashback Spending',
      },
      BUY_X_ORDERS: {
        title: 'On X Orders Get Y',
      },
      REFER_FRIEND: {
        title: 'Refer a Friend',
      },
    },
    ACTIONS: {
      SEND_COUPON_CODE: {
        title: 'Coupon'
      },
      SEND_PRODUCT: {
        title: 'Product'
      },
      TOP_UP_BALANCE_AMOUNT: {
        title: 'Balance'
      },
      TOP_UP_BALANCE_PERCENT: {
        title: 'Balance'
      }
    }
  },

  STRIPE: {
    PUBLIC_KEY: 'pk_live_51JpGudGGvSAAHahB4rQbESNBf5Lm7bUOBLfpzqbithD4MTr9zhWN1SUx134s7MLODCj11W7Y1S7mqrT8iUjdoPah00gksKbsKb',
    // PUBLIC_KEY: 'pk_test_51PQbWuGx9GZvVjwlvXlv3qtr3lpqdP6spzmqOiH7zXT0WLdZTNx7uGHevWbd3qx4Bj4lLQKxo8V34ymdcxOqNmX500OXYra1Eq',
  },

  PAYPAL: {
    CLIENT_ID: 'AZ_Xr_yxsGGwzejUIE20swinmMucc5htJz45lfX92hUWFxlxgty5X03-FtuQDcjM65JA_uYwzAWe-O9I',
  },
}

export default config;


export const formData = (obj: any): any => {
  const form_data = new FormData();

  for (const key in obj) {
    form_data.append(key, obj[key]);
  }

  return form_data
}

export const getCDNLink = ({ id, type }: { id: string, type?: string }): any => {
  if(id) {
    return `https://imagedelivery.net/95QNzrEeP7RU5l5WdbyrKw/${id}/${type ? type.toLowerCase() : 'default'}`
  } else {
    return "";
  }
}

export const search = (data: any[], filters: string[], searchKey: string): any =>
  data.filter((item) => {
    for (let i = 0; i < filters.length; i++) {
      const prod = item[filters[i]];
      if (
        (prod || (prod === 0 && filters[i] === 'stock')) &&
                prod.toString().toLowerCase().includes(searchKey.toLowerCase())
      ) {
        return true;
      }
    }
    return false;
  });

export const random = (min: number, max?: number, round?: boolean): any => {
  const randomNumber = Math.floor(Math.random() * ((max ? max : min) - min + 1) + min);
  return round ? Math.round(randomNumber / 10) * 10 : randomNumber;
};

export const orderStatus = (t: any): any => {
  return {
    PENDING: t('PENDING') as string,
    COMPLETED: t('COMPLETED') as string,
    ENDED: t('ENDED') as string,
    ACTIVE: t('ACTIVE') as string,
    VOIDED: t('VOIDED') as string,
    CANCELED: t('VOIDED') as string,
    CANCELLED: t('VOIDED') as string,
    WAITING_FOR_CONFIRMATIONS: t('WAITING_FOR_CONFIRMATIONS') as string,
    WAITING_SHOP_ACTION: t('WAITING_SHOP_ACTION') as string,
    PARTIAL: t('PARTIAL') as string,
    REVERSED: t('REVERSED') as string,
    REFUNDED: t('REFUNDED') as string,
    CUSTOMER_DISPUTE_ONGOING: t('CUSTOMER_DISPUTE_ONGOING') as string,
    PROCESSED: "PROCESSED" as string,
    AWAIT_CANCELING: t('AWAIT_CANCELING') as string,
    TRIALING: t('TRIALING') as string,
  }
}
